import React from 'react'



function IstProgress(props) {
    const message = props.message || '';
    const spinnerName = props.spinnerName || 'three-bounce';
  
    return (
      <div className='loading__progress__wrapper'>
        <div className='loading__message'>
          <span>{message}</span>
        </div>
        <div className='loading__progress'>
          <div spinnerName={spinnerName} />
        </div>
      </div>
    );
}
  
export default IstProgress;

